"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.SUBSCRIPTION_TYPES = exports.REGISTER_STATUS = exports.HIBERNATION_MODE_STATES = exports.TRANSLATION_METHOD = exports.TRACKING_METHOD = exports.NOTIFICATION_METHODS = exports.INCIDENT_METHODS = exports.CONFIG_KEYS = exports.REGION_INFORMATION_FLAGS = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var _ErrorHelper = require("../helpers/ErrorHelper");

var _strings = require("../../config/strings");

var _DeviceInfoHelper = _interopRequireDefault(require("../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _TimeoutHelper = require("../helpers/TimeoutHelper");

var _ArrayHelper = require("../helpers/ArrayHelper");

var _DownloadHelper = _interopRequireDefault(require("../helpers/DownloadHelper"));

var _MuiAlertHelper = require("../helpers/MuiAlertHelper");

var _LogService = require("../KESI2/Services/LogService");

var _HttpRequest = require("../utils/HttpRequest");

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _PromiseHelper = require("../utils/PromiseHelper");

var _TCUserManager = require("../helpers/TCUserManager");

var _BuildConstants = require("../utils/BuildConstants");

var _ResumeSuspendListeners = require("../helpers/ResumeSuspendListeners");

/**
 * This data is also available through window.SafeturePlugin.REGION_INFORMATION_FLAGS
 */
var REGION_INFORMATION_FLAGS = {
  BASIC: 1,
  CONTENT_NODES: 2,
  RECENT_INCIDENTS: 4,
  EMBASSIES: 8,
  ASSISTANCE_INFORMATION: 16,
  THREAT_ASSESSMENTS: 32,
  // IMAGES: 64,   // deprecated - download images separately using Safeture.downloadRegionImage(regionName)
  ALL: 255
};
/**
 * This data is also available through window.SafeturePlugin.CONFIG_KEYS
 */

exports.REGION_INFORMATION_FLAGS = REGION_INFORMATION_FLAGS;
var CONFIG_KEYS = {
  INCIDENT_METHOD: 'incidentMethod',
  NOTIFICATION_METHOD: 'notificationMethod',
  PREFERRED_LANGUAGE: 'preferredLanguage',
  REGIONS_OF_INTEREST: 'regionsOfInterest',
  SERVICE_ENABLED: 'serviceEnabled',
  TRACKING_METHOD: 'trackingMethod',
  TRANSLATION_METHOD: 'translationMethod'
};
/**
 * This data is also available through window.SafeturePlugin.INCIDENT_METHODS
 */

exports.CONFIG_KEYS = CONFIG_KEYS;
var INCIDENT_METHODS = {
  CURRENT_COUNTRY_AND_NEARBY: 'current_country_and_nearby',
  CURRENT_COUNTRY_AND_REGIONS_AND_NEARBY: 'current_country_and_regions_and_nearby',
  REGIONS_AND_NEARBY: 'regions_and_nearby',
  WORLD: 'world',
  UNKNOWN: 'unknown'
};
/**
 * This data is also available through window.SafeturePlugin.NOTIFICATION_METHODS
 */

exports.INCIDENT_METHODS = INCIDENT_METHODS;
var NOTIFICATION_METHODS = {
  CURRENT_COUNTRY_AND_NEARBY: 'current_country_and_nearby',
  CURRENT_COUNTRY_AND_REGIONS_AND_NEARBY: 'current_country_and_regions_and_nearby',
  REGIONS_AND_NEARBY: 'regions_and_nearby',
  NEARBY: 'nearby',
  WORLD: 'world',
  UNKNOWN: 'unknown'
};
/**
 * This data is also available through window.SafeturePlugin.TRACKING_METHOD
 */

exports.NOTIFICATION_METHODS = NOTIFICATION_METHODS;
var TRACKING_METHOD = {
  DISABLED: 'disabled',
  REGION: 'region',
  SUBREGION: 'subregion',
  CITY: 'city',
  PRECISE: 'precise'
};
/**
 * This data is also available through window.SafeturePlugin.TRANSLATION_METHOD
 */

exports.TRACKING_METHOD = TRACKING_METHOD;
var TRANSLATION_METHOD = {
  NATIVE_ONLY: 'native_only',
  ALLOW_MACHINE: 'allow_machine',
  UNKNOWN: 'unknown'
};
exports.TRANSLATION_METHOD = TRANSLATION_METHOD;
var HIBERNATION_MODE_STATES = {
  ACTIVE: 'ACTIVE',
  ERROR: 'ERROR',
  DISABLED: 'DISABLED',
  NOT_AVAIL: 'FEATURE_NOT_AVAILABLE'
}; // de.equeo.ervtest
// const KEYS_DEV = {
//   API_KEY: '408815de-d426-11e7-b794-afe1c5a29a0f',
//   SUBSCRIPTION_ID: '12426637'
// }
// de.equeo.tcv2preview
// const KEYS_DEV = {
//   API_KEY: 'd39f95dc-fb5d-11e7-86e6-fb887d62d2fb',
//   SUBSCRIPTION_ID: '33912771'
// }

exports.HIBERNATION_MODE_STATES = HIBERNATION_MODE_STATES;
var CACHE = {};
var CACHE_INVALIDATE_TIME = 5 * 60 * 1000; // 5 min

var FAILURE_DIALOG_REPETITION_TIME = 10 * 60 * 10000; // 10 min

var HIBERNATION_MODE_DIALOG_REPETITION_TIME = 7 * 24 * 60 * 60 * 10000; // Alle 7 Tagen
// const IMAGE_URL = 'https://erv-dev-geo.equeo.de/config/region_images'

var IOS_CAN_GET_LOCATION_FROM_SDK = true;
var ASKED_FOR_BACKGROUND_COUNT = 0;
var REGISTER_STATUS = {
  UNREGISTERED: 0,
  IN_TRIAL: 1,
  REGISTERED: 2,
  CUSTOMER: 3
};
exports.REGISTER_STATUS = REGISTER_STATUS;
var SUBSCRIPTION_TYPES = {
  REGISTERED: 'registered',
  TRIAL: 'trial'
};
exports.SUBSCRIPTION_TYPES = SUBSCRIPTION_TYPES;

var Safeture = /*#__PURE__*/function () {
  function Safeture() {
    var _this = this;

    (0, _classCallCheck2["default"])(this, Safeture);
    (0, _defineProperty2["default"])(this, "init", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var force,
          _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              force = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              console.log('safeture init');
              _context.prev = 2;
              _context.next = 5;
              return _this._init(15, force);

            case 5:
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
              // ignore
              console.error('error initializing Safeture', _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 7]]);
    })));
    (0, _defineProperty2["default"])(this, "activateUser", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(type) {
        var showErrorToUser,
            subscriptionId,
            buttons,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                showErrorToUser = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
                _context3.prev = 1;

                if (!(type === SUBSCRIPTION_TYPES.REGISTERED)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 5;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_SUBSCRIPTION_ID_CUSTOMER);

              case 5:
                subscriptionId = _context3.sent;
                _context3.next = 11;
                break;

              case 8:
                _context3.next = 10;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_SUBSCRIPTION_ID);

              case 10:
                subscriptionId = _context3.sent;

              case 11:
                console.log('subscribing user for safeture with subscription key', subscriptionId);

                if (!subscriptionId) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 15;
                return _this._subscribe(subscriptionId);

              case 15:
                _context3.next = 24;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](1);
                console.error('Error subscribing at Safeture via SDK', _context3.t0);

                if (showErrorToUser) {
                  _context3.next = 22;
                  break;
                }

                throw _context3.t0;

              case 22:
                buttons = [{
                  label: (0, _strings.getString)('RETRY'),
                  callback: function () {
                    var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
                      return _regenerator["default"].wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.prev = 0;
                              _context2.next = 3;
                              return _this.activateCustomer();

                            case 3:
                              _context2.next = 7;
                              break;

                            case 5:
                              _context2.prev = 5;
                              _context2.t0 = _context2["catch"](0);

                            case 7:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2, null, [[0, 5]]);
                    }));

                    function callback() {
                      return _callback.apply(this, arguments);
                    }

                    return callback;
                  }()
                }];
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  html: (0, _strings.getString)('TC_ERROR_REGISTERING_SAFETURE_MESSAGE'),
                  severity: _MuiAlertHelper.SEVERITIES.HIGH,
                  showCloseButton: false,
                  buttons: buttons
                });

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 17]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "activateTrial", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var showErrorToUser,
          _args4 = arguments;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              showErrorToUser = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;

              _this.activateUser(SUBSCRIPTION_TYPES.TRIAL, showErrorToUser);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));
    (0, _defineProperty2["default"])(this, "activateCustomer", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var showErrorToUser,
          _args5 = arguments;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              showErrorToUser = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : true;

              _this.activateUser(SUBSCRIPTION_TYPES.REGISTERED, showErrorToUser);

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty2["default"])(this, "checkIfHibernationModeActive", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
      var getOnlyStatus,
          lastCheck,
          value,
          hibernateDialog,
          innerButton,
          cancelButton,
          _args7 = arguments;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              getOnlyStatus = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : false;
              lastCheck = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_HIBERNATION_MODE_LAST_CHECKED);
              _context7.prev = 2;

              if (!(_DeviceInfoHelper["default"].isiOS() || (0, _now["default"])() - lastCheck < HIBERNATION_MODE_DIALOG_REPETITION_TIME)) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return", false);

            case 5:
              _context7.next = 7;
              return window.SafeturePlugin.checkIfHibernationModeActive();

            case 7:
              value = _context7.sent;

              if (!getOnlyStatus) {
                _context7.next = 10;
                break;
              }

              return _context7.abrupt("return", value);

            case 10:
              _context7.next = 12;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_HIBERNATION_MODE_STATE, value);

            case 12:
              _context7.next = 14;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_HIBERNATION_MODE_LAST_CHECKED, (0, _now["default"])());

            case 14:
              if (value === HIBERNATION_MODE_STATES.ACTIVE) {
                innerButton = {
                  callback: function () {
                    var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
                      return _regenerator["default"].wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.prev = 0;
                              _context6.next = 3;
                              return window.SafeturePlugin.deactivateHibernationMode();

                            case 3:
                              if (hibernateDialog) hibernateDialog();
                              _context6.next = 9;
                              break;

                            case 6:
                              _context6.prev = 6;
                              _context6.t0 = _context6["catch"](0);
                              console.log('error deactivating hibernation mode');

                            case 9:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6, null, [[0, 6]]);
                    }));

                    function callback() {
                      return _callback2.apply(this, arguments);
                    }

                    return callback;
                  }(),
                  label: (0, _strings.getString)('TC_DEACTIVATE_HIBERNATION_MODE_TO_SETTINGS')
                };
                cancelButton = {
                  callback: function callback() {},
                  label: (0, _strings.getString)('TC_DEACTIVATE_HIBERNATION_MODE_NOT_NOW')
                };
                setTimeout(function () {
                  hibernateDialog = (0, _MuiAlertHelper.showAlertWithOptions)({
                    title: (0, _strings.getString)('TC_EXPLANATION_DEACTIVATE_HIBERNATION_MODE_TITLE'),
                    html: (0, _strings.getString)('TC_EXPLANATION_DEACTIVATE_HIBERNATION_MODE_MESSAGE'),
                    severity: _MuiAlertHelper.SEVERITIES.HIGH,
                    buttons: [cancelButton, innerButton],
                    showCloseButton: false
                  });
                }, 0);
              }

              _context7.next = 21;
              break;

            case 17:
              _context7.prev = 17;
              _context7.t0 = _context7["catch"](2);
              console.error('error checking hibernate mode dialog');
              return _context7.abrupt("return", false);

            case 21:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 17]]);
    })));
    (0, _defineProperty2["default"])(this, "_init", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
      var tryCount,
          force,
          appInstanceId,
          privacyAccepted,
          userRole,
          isRegistered,
          isSubscribed,
          keysFromDataStore,
          alreadySubscribed,
          alreadyRegistered,
          regionsToRequest,
          currentRegion,
          homeRegion,
          userRegions,
          i,
          _args12 = arguments;
      return _regenerator["default"].wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              tryCount = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : 15;
              force = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : false;

              if (!window.SafeturePlugin.appMustEnableLocationServicesCallback) {
                window.SafeturePlugin.appMustEnableLocationServicesCallback = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
                  return _regenerator["default"].wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          IOS_CAN_GET_LOCATION_FROM_SDK = false;
                          console.log('did get appMustEnableLocationServicesCallback');
                          (0, _LogService.pushTravelAndCareLogMessage)('appMustEnableLocationServicesCallback');
                          (0, _MuiAlertHelper.showAlertWithOptions)({
                            title: (0, _strings.getString)('TC_APP_BACKGROUND_WRONG_CHOSEN_TITLE'),
                            message: (0, _strings.getString)('TC_APP_BACKGROUND_WRONG_CHOSEN_MESSAGE'),
                            debugModeOnly: true
                          });

                        case 4:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }));
              }

              appInstanceId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.APP_INSTANCE_PATH);

              if (appInstanceId) {
                // don't wait for it
                window.SafeturePlugin.saveApplicationInstanceId(appInstanceId)["catch"](function (error) {
                  console.error('error saving app instance id in native code', error);
                });
              }

              _context12.next = 7;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_REGION_INFO_CACHE);

            case 7:
              _context12.t0 = _context12.sent;

              if (_context12.t0) {
                _context12.next = 10;
                break;
              }

              _context12.t0 = {};

            case 10:
              CACHE = _context12.t0;
              privacyAccepted = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_PRIVACY_ACCEPTED);

              if (privacyAccepted) {
                _context12.next = 14;
                break;
              }

              return _context12.abrupt("return", new _promise["default"](function (resolve, reject) {
                var rmFunc = _DataStore["default"].addOnChangeListener( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
                  return _regenerator["default"].wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_PRIVACY_ACCEPTED);

                        case 2:
                          if (!_context9.sent) {
                            _context9.next = 5;
                            break;
                          }

                          rmFunc(); // use setTimeout to avoid potential stack depth exceeded error

                          setTimeout(function () {
                            _this._init().then(resolve);
                          });

                        case 5:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                })));
              }));

            case 14:
              _context12.next = 16;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_USER_ROLE);

            case 16:
              userRole = _context12.sent;

              if (!(userRole === REGISTER_STATUS.UNREGISTERED)) {
                _context12.next = 21;
                break;
              }

              console.log('Safeture not initializing when user role is unregistered');
              (0, _MuiAlertHelper.showAlertWithOptions)({
                title: 'Not registering',
                message: 'Trial over, not registered, wont subscribe',
                debugModeOnly: true
              });
              return _context12.abrupt("return");

            case 21:
              console.log('safeture _init', tryCount, force);

              if (!(_this.initInProgress && !force)) {
                _context12.next = 25;
                break;
              }

              console.log('safeture init process already running');
              return _context12.abrupt("return", _this._waitForInitialized());

            case 25:
              _this.initInProgress = true;
              console.log('safeture _init pre request permissions');
              _context12.prev = 27;
              console.log('requestingPermissions');
              _context12.next = 31;
              return _this._requestPermissions();

            case 31:
              _context12.next = 37;
              break;

            case 33:
              _context12.prev = 33;
              _context12.t1 = _context12["catch"](27);
              console.error('Error requesting permissions via SafetureSDK', _context12.t1);
              (0, _MuiAlertHelper.showAlertInDebugMode)('Error requesting permissions via SafetureSDK', (0, _ErrorHelper.getErrorMessage)(_context12.t1)); // this.initInProgress = false

            case 37:
              // }
              console.log('safeture _init pre checkHibernate');

              if (!_DeviceInfoHelper["default"].isAndroid()) {
                _context12.next = 41;
                break;
              }

              _context12.next = 41;
              return _this.checkIfHibernationModeActive();

            case 41:
              console.log('safeture _init post checkHibernate');
              console.log('safeture _init is online: ', _DeviceInfoHelper["default"].isOnline()); // const registrationId = await window.SafeturePlugin.getRegistrationId()
              // console.log('Safeture registration is', registrationId || 'n/a')

              _context12.next = 45;
              return window.SafeturePlugin.isRegistered();

            case 45:
              isRegistered = _context12.sent;
              _context12.t2 = isRegistered;

              if (!_context12.t2) {
                _context12.next = 51;
                break;
              }

              _context12.next = 50;
              return window.SafeturePlugin.isSubscribed();

            case 50:
              _context12.t2 = _context12.sent;

            case 51:
              isSubscribed = _context12.t2;

              if (!(!isRegistered || !isSubscribed)) {
                _context12.next = 118;
                break;
              }

              _context12.next = 55;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_KEYS);

            case 55:
              keysFromDataStore = _context12.sent;

              if (!(!isRegistered && !_DeviceInfoHelper["default"].isOnline() || !keysFromDataStore)) {
                _context12.next = 69;
                break;
              }

              if (!(tryCount === 0)) {
                _context12.next = 63;
                break;
              }

              console.log('add online listener'); // in case there was one listener added previously

              _DeviceInfoHelper["default"].removeOnlineListener(_this.init);

              _DeviceInfoHelper["default"].addOnlineListener(_this.init);

              _context12.next = 69;
              break;

            case 63:
              console.log('retry init in 300ms');
              _this.initInProgress = false;
              _context12.next = 67;
              return (0, _TimeoutHelper.timeout)(300);

            case 67:
              _context12.next = 69;
              return _this._init(tryCount - 1);

            case 69:
              // in case there was one listener added previously
              _DeviceInfoHelper["default"].removeOnlineListener(_this.init);

              _context12.prev = 70;

              if (isRegistered) {
                _context12.next = 84;
                break;
              }

              if (!(userRole === REGISTER_STATUS.REGISTERED || userRole === REGISTER_STATUS.CUSTOMER)) {
                _context12.next = 80;
                break;
              }

              console.log('registering at Safeture with production keys');

              if (!keysFromDataStore.API_KEY_CUSTOMER) {
                _context12.next = 78;
                break;
              }

              _context12.next = 77;
              return _this._register(keysFromDataStore.API_KEY_CUSTOMER);

            case 77:
              console.log('successfully registered at Safeture');

            case 78:
              _context12.next = 84;
              break;

            case 80:
              console.log('registering at Safeture with trial keys', keysFromDataStore.API_KEY);
              _context12.next = 83;
              return _this._register(keysFromDataStore.API_KEY);

            case 83:
              console.log('successfully registered at Safeture');

            case 84:
              if (!(!isRegistered || !isSubscribed)) {
                _context12.next = 103;
                break;
              }

              if (!(userRole === REGISTER_STATUS.REGISTERED || userRole === REGISTER_STATUS.CUSTOMER)) {
                _context12.next = 93;
                break;
              }

              if (!keysFromDataStore.SUBSCRIPTION_ID_CUSTOMER) {
                _context12.next = 91;
                break;
              }

              console.log('subscribing to Safeture with production keys');
              _context12.next = 90;
              return _this._subscribe(keysFromDataStore.SUBSCRIPTION_ID_CUSTOMER);

            case 90:
              console.log('successfully subscribed at Safeture');

            case 91:
              _context12.next = 103;
              break;

            case 93:
              _context12.next = 95;
              return window.SafeturePlugin.isSubscribed();

            case 95:
              alreadySubscribed = _context12.sent;
              _context12.next = 98;
              return window.SafeturePlugin.isRegistered();

            case 98:
              alreadyRegistered = _context12.sent;
              console.log('subscribing to Safeture with trial keys', keysFromDataStore.SUBSCRIPTION_ID, alreadySubscribed, alreadyRegistered);
              _context12.next = 102;
              return _this._subscribe(keysFromDataStore.SUBSCRIPTION_ID);

            case 102:
              console.log('successfully subscribed at Safeture');

            case 103:
              if (_this.allRegions) {
                _context12.next = 113;
                break;
              }

              _context12.prev = 104;
              _context12.next = 107;
              return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getAvailableRegions(), 30000);

            case 107:
              _this.allRegions = _context12.sent;
              _context12.next = 113;
              break;

            case 110:
              _context12.prev = 110;
              _context12.t3 = _context12["catch"](104);
              console.error('Error loading all regions in init process', _context12.t3); // ignore

            case 113:
              _context12.next = 118;
              break;

            case 115:
              _context12.prev = 115;
              _context12.t4 = _context12["catch"](70);
              return _context12.abrupt("return", new _promise["default"](function (resolve, reject) {
                console.error('Error registering at Safeture via SDK', _context12.t4);
                var buttons = [{
                  label: (0, _strings.getString)('RETRY'),
                  callback: function () {
                    var _callback3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10() {
                      return _regenerator["default"].wrap(function _callee10$(_context10) {
                        while (1) {
                          switch (_context10.prev = _context10.next) {
                            case 0:
                              _context10.prev = 0;
                              _this.initInProgress = false;
                              _context10.next = 4;
                              return _this._init(tryCount);

                            case 4:
                              resolve();
                              _context10.next = 10;
                              break;

                            case 7:
                              _context10.prev = 7;
                              _context10.t0 = _context10["catch"](0);
                              reject(_context10.t0);

                            case 10:
                            case "end":
                              return _context10.stop();
                          }
                        }
                      }, _callee10, null, [[0, 7]]);
                    }));

                    function callback() {
                      return _callback3.apply(this, arguments);
                    }

                    return callback;
                  }()
                }];
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  html: (0, _strings.getString)('TC_ERROR_REGISTERING_SAFETURE_MESSAGE'),
                  severity: _MuiAlertHelper.SEVERITIES.HIGH,
                  showCloseButton: false,
                  buttons: buttons
                });
              }));

            case 118:
              if (!(!isRegistered || !isSubscribed)) {
                _context12.next = 147;
                break;
              }

              _context12.prev = 119;
              regionsToRequest = [];
              _context12.prev = 121;
              _context12.next = 124;
              return window.SafeturePlugin.getCurrentRegion(false);

            case 124:
              currentRegion = _context12.sent;
              _context12.next = 130;
              break;

            case 127:
              _context12.prev = 127;
              _context12.t5 = _context12["catch"](121);
              console.error('Error getting current region in initial init'); // ignore

            case 130:
              homeRegion = _config["default"].tcCountryHelper.getCountryByCode(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE), 'en');

              if (currentRegion) {
                regionsToRequest.push(currentRegion);
              }

              if (homeRegion && homeRegion !== currentRegion) {
                regionsToRequest.push(homeRegion);
              }

              userRegions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_USER_REGION_CODES);

              if (userRegions) {
                userRegions.forEach(function (regionCode) {
                  regionsToRequest.push(_config["default"].tcCountryHelper.getCountryByCode(regionCode, 'en'));
                });
              }

              console.log('regions to request in init', regionsToRequest);

              if (!(regionsToRequest.length > 0)) {
                _context12.next = 142;
                break;
              }

              _context12.next = 139;
              return (0, _PromiseHelper.timeoutPromise)(_this.getRegionsInformation(regionsToRequest, REGION_INFORMATION_FLAGS.BASIC, {}, true, false, false), 60000);

            case 139:
              console.log('successfully got regions in init'); // NO AWAIT HERE, otherwise the request is blocking

              _this.setConfig({
                regionsOfInterest: regionsToRequest
              });

              console.log('successfully got regions in init');

            case 142:
              _context12.next = 147;
              break;

            case 144:
              _context12.prev = 144;
              _context12.t6 = _context12["catch"](119);
              return _context12.abrupt("return", new _promise["default"](function (resolve, reject) {
                console.error('Error loading region information', _context12.t6);
                var buttons = [{
                  label: (0, _strings.getString)('RETRY'),
                  callback: function () {
                    var _callback4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
                      return _regenerator["default"].wrap(function _callee11$(_context11) {
                        while (1) {
                          switch (_context11.prev = _context11.next) {
                            case 0:
                              _context11.prev = 0;
                              _this.initInProgress = false;
                              _context11.next = 4;
                              return _this._init(tryCount);

                            case 4:
                              resolve();
                              _context11.next = 10;
                              break;

                            case 7:
                              _context11.prev = 7;
                              _context11.t0 = _context11["catch"](0);
                              reject(_context11.t0);

                            case 10:
                            case "end":
                              return _context11.stop();
                          }
                        }
                      }, _callee11, null, [[0, 7]]);
                    }));

                    function callback() {
                      return _callback4.apply(this, arguments);
                    }

                    return callback;
                  }()
                }];
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  html: (0, _strings.getString)('TC_ERROR_REGISTERING_SAFETURE_MESSAGE'),
                  severity: _MuiAlertHelper.SEVERITIES.HIGH,
                  showCloseButton: false,
                  buttons: buttons
                });
              }));

            case 147:
              if (!(!isRegistered || !isSubscribed || !_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_PHONE_NUMBER_MIGRATED))) {
                _context12.next = 150;
                break;
              }

              _context12.next = 150;
              return _this.migratePhoneNumberAndRegisterPolicyNumberFromOldApp();

            case 150:
              _this._initListeners();

              _this.isInitialized = true;
              _this.initInProgress = false;
              i = 0;

            case 154:
              if (!(i < _this.initializedListeners.length)) {
                _context12.next = 160;
                break;
              }

              _context12.next = 157;
              return _this.initializedListeners[i]();

            case 157:
              i++;
              _context12.next = 154;
              break;

            case 160:
              _this.initializedListeners = []; // save safeture registration id to DataStore -> triggered by this function call

              _this.getRegistrationId(); // request current location once at start, save it window.navigator.geolocation.SafetureLocation


              _this.getCurrentLocation(); // this.downloadAllImages()
              // if (target.trackGeolocationForTrackingInformation) {
              //   setInterval(() => {
              //     this.getCurrentLocation()
              //   }, LOCATION_UPDATE_INTERVAL)
              // }


            case 163:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[27, 33], [70, 115], [104, 110], [119, 144], [121, 127]]);
    })));
    (0, _defineProperty2["default"])(this, "asyncForEach", /*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(array, callback) {
        var index;
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                index = 0;

              case 1:
                if (!(index < array.length)) {
                  _context13.next = 7;
                  break;
                }

                _context13.next = 4;
                return callback(array[index], index, array);

              case 4:
                index++;
                _context13.next = 1;
                break;

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x2, _x3) {
        return _ref9.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])(this, "checkIfRegistered", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
      var isRegistered;
      return _regenerator["default"].wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return window.SafeturePlugin.isRegistered();

            case 2:
              isRegistered = _context14.sent;
              return _context14.abrupt("return", isRegistered);

            case 4:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    })));
    (0, _defineProperty2["default"])(this, "unregister", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15() {
      var isRegistered, apiKey;
      return _regenerator["default"].wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              console.log('unregister safeture');
              _context15.next = 3;
              return window.SafeturePlugin.isRegistered();

            case 3:
              isRegistered = _context15.sent;

              if (!isRegistered) {
                _context15.next = 21;
                break;
              }

              _context15.prev = 5;
              console.log('really unregister safeture');
              _context15.next = 9;
              return window.SafeturePlugin.unregister();

            case 9:
              _context15.next = 11;
              return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_API_KEY_CUSTOMER);

            case 11:
              apiKey = _context15.sent;
              console.log('registering again with apiKey', apiKey);
              _context15.next = 15;
              return window.SafeturePlugin.registerWithKey(apiKey);

            case 15:
              _context15.next = 21;
              break;

            case 17:
              _context15.prev = 17;
              _context15.t0 = _context15["catch"](5);
              console.error('Error unregistering from Safeture SDK', _context15.t0);
              return _context15.abrupt("return", _promise["default"].reject(_context15.t0));

            case 21:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[5, 17]]);
    })));
    (0, _defineProperty2["default"])(this, "savePolicyNumberAfterUpgradeFromOldApp", /*#__PURE__*/function () {
      var _ref12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(homeRegionCode, policyNumber, phoneNumber) {
        var token, params, response;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return _RegisterInstance["default"].getAccessToken('dataStore:read');

              case 3:
                token = _context16.sent;
                params = {
                  policyNumber: "".concat(homeRegionCode).concat(policyNumber),
                  phoneNumber: phoneNumber
                };
                _context16.next = 7;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.POLICY_HOST, "/rest/v1/policyDetails"), params, null, false, 10000, 10, 'Bearer ' + token);

              case 7:
                response = _context16.sent;

                if (!(response && response.data)) {
                  _context16.next = 13;
                  break;
                }

                _context16.next = 11;
                return (0, _TCUserManager.registerTCUser)(response.data);

              case 11:
                _context16.next = 14;
                break;

              case 13:
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: 'Error registering your previously registered policy',
                  message: 'Did not get a response from the server'
                });

              case 14:
                _context16.next = 19;
                break;

              case 16:
                _context16.prev = 16;
                _context16.t0 = _context16["catch"](0);
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: 'Error registering your previously registered policy',
                  message: _context16.t0.message
                });

              case 19:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[0, 16]]);
      }));

      return function (_x4, _x5, _x6) {
        return _ref12.apply(this, arguments);
      };
    }());
    this.isInitialized = false;
    this.initializedListeners = [];
    this.initInProgress = false;
    this.apiKey = null;
    this.apiSubscriptionId = null;
    this.validatedPhoneNumber = null;
    this.incidents = null;
    this.regionInfos = null;
    this.currentRegion = null;
    this.currentLocation = null;
    this.regionRequestQueue = [];
    this.isRequestingRegionInformation = false;
    this.configWriteQueue = [];
    this.isWritingConfig = false;
    this.failureRetryInterval = null;
    this.policyNumberToUseAfterPhoneNumberMigration = null;
    this.homeRegionToUseAfterPhoneNumberMigration = null;
    this.alreadyShownLocationWarning = false;
  }

  (0, _createClass2["default"])(Safeture, [{
    key: "downloadRegionImages",

    /**
     * Downloads the region image for the given region
     *
     * @param regionNames - Use the Safeture region names in an Array
     * @param reloadIfExists
     * @returns {Promise<String>} The promise returns the file path for that image
     */
    value: function () {
      var _downloadRegionImages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(regionNames) {
        var reloadIfExists,
            _args17 = arguments;
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                reloadIfExists = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : false;
                return _context17.abrupt("return", _promise["default"].all(regionNames.map(function (regionName) {
                  var regionNameEscaped = regionName.replace(/ /g, '_').replace(/&/g, 'and');
                  return _DownloadHelper["default"].download("".concat(_BuildConstants.REGION_IMAGE_HOST, "/").concat(regionNameEscaped, ".jpg"), "".concat(regionNameEscaped, ".jpg"), reloadIfExists ? -1 : null);
                })));

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function downloadRegionImages(_x7) {
        return _downloadRegionImages.apply(this, arguments);
      }

      return downloadRegionImages;
    }()
  }, {
    key: "getValidatedPhoneNumber",
    value: function () {
      var _getValidatedPhoneNumber = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18() {
        var validatedPhoneNumber;
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this._waitForInitialized();

              case 2:
                if (!this.validatedPhoneNumber) {
                  _context18.next = 4;
                  break;
                }

                return _context18.abrupt("return", this.validatedPhoneNumber());

              case 4:
                _context18.prev = 4;
                _context18.next = 7;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getValidatedPhoneNumber(), 10000);

              case 7:
                validatedPhoneNumber = _context18.sent;

                if (validatedPhoneNumber !== 'null') {
                  this.validatedPhoneNumber = validatedPhoneNumber;
                }

                return _context18.abrupt("return", this.validatedPhoneNumber);

              case 12:
                _context18.prev = 12;
                _context18.t0 = _context18["catch"](4);
                console.error('Error getting validated phone number from Safeture SDK', _context18.t0);
                return _context18.abrupt("return", _promise["default"].resolve(null));

              case 16:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[4, 12]]);
      }));

      function getValidatedPhoneNumber() {
        return _getValidatedPhoneNumber.apply(this, arguments);
      }

      return getValidatedPhoneNumber;
    }()
  }, {
    key: "getRegistrationIdImmediately",
    value: function getRegistrationIdImmediately() {
      return _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_REGISTRATION_ID);
    }
  }, {
    key: "getRegistrationId",
    value: function () {
      var _getRegistrationId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
        var prevRegistrationId, registrationId;
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this._waitForInitialized();

              case 2:
                prevRegistrationId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_REGISTRATION_ID);
                _context19.prev = 3;
                _context19.next = 6;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getRegistrationId(), 10000);

              case 6:
                registrationId = _context19.sent;

                if (registrationId && prevRegistrationId !== registrationId) {
                  _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_REGISTRATION_ID, registrationId);
                }

                return _context19.abrupt("return", registrationId);

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19["catch"](3);
                console.error('Error getting registration ID from Safeture SDK', _context19.t0);
                return _context19.abrupt("return", _promise["default"].resolve(null));

              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[3, 11]]);
      }));

      function getRegistrationId() {
        return _getRegistrationId.apply(this, arguments);
      }

      return getRegistrationId;
    }()
  }, {
    key: "getIncidentFeed",
    value: function () {
      var _getIncidentFeed = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20() {
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this._waitForInitialized();

              case 2:
                _context20.prev = 2;
                _context20.next = 5;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getIncidentFeed(), 30000);

              case 5:
                return _context20.abrupt("return", _context20.sent);

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](2);
                console.error('Error getting incident feed from Safeture SDK', _context20.t0);
                return _context20.abrupt("return", _promise["default"].resolve(null));

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[2, 8]]);
      }));

      function getIncidentFeed() {
        return _getIncidentFeed.apply(this, arguments);
      }

      return getIncidentFeed;
    }()
  }, {
    key: "getCurrentLocation",
    value: function () {
      var _getCurrentLocation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this._waitForInitialized();

              case 2:
                _context21.prev = 2;
                _context21.next = 5;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getCurrentLocation(), 10000);

              case 5:
                this.currentLocation = _context21.sent;
                // propagate globally
                window.navigator.geolocation.SafetureLocation = this.currentLocation;
                return _context21.abrupt("return", this.currentLocation);

              case 10:
                _context21.prev = 10;
                _context21.t0 = _context21["catch"](2);
                console.error('Error getting current location from Safeture SDK', _context21.t0);
                return _context21.abrupt("return", _promise["default"].resolve(null));

              case 14:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[2, 10]]);
      }));

      function getCurrentLocation() {
        return _getCurrentLocation.apply(this, arguments);
      }

      return getCurrentLocation;
    }()
  }, {
    key: "getCurrentRegion",
    value: function () {
      var _getCurrentRegion = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
        var waitForInitialized,
            lastKnownRegion,
            currentRegion,
            _args22 = arguments;
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                waitForInitialized = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : true;

                if (!waitForInitialized) {
                  _context22.next = 4;
                  break;
                }

                _context22.next = 4;
                return this._waitForInitialized();

              case 4:
                lastKnownRegion = _config["default"].tcCountryHelper.getCountryByCode(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_CURRENT_REGION_CODE));
                _context22.prev = 5;

                if (!IOS_CAN_GET_LOCATION_FROM_SDK) {
                  _context22.next = 10;
                  break;
                }

                _context22.next = 9;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getCurrentRegion(), 10000);

              case 9:
                currentRegion = _context22.sent;

              case 10:
                if (!currentRegion && lastKnownRegion) {
                  currentRegion = lastKnownRegion;
                } else if (currentRegion !== lastKnownRegion) {
                  _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_CURRENT_REGION_CODE, _config["default"].tcCountryHelper.getCodeByCountry(currentRegion));
                }

                console.log('getCurrentRegion', currentRegion);
                this.currentRegion = currentRegion;
                return _context22.abrupt("return", currentRegion);

              case 16:
                _context22.prev = 16;
                _context22.t0 = _context22["catch"](5);
                console.error('Error getting current region from Safeture SDK. Using fallback (last known location)', lastKnownRegion || 'n/a', _context22.t0);
                return _context22.abrupt("return", lastKnownRegion);

              case 20:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[5, 16]]);
      }));

      function getCurrentRegion() {
        return _getCurrentRegion.apply(this, arguments);
      }

      return getCurrentRegion;
    }()
  }, {
    key: "getAvailableRegions",
    value: function () {
      var _getAvailableRegions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this._waitForInitialized();

              case 2:
                if (!(!this.allRegions || this.allRegions.length === 0)) {
                  _context23.next = 16;
                  break;
                }

                _context23.prev = 3;
                _context23.next = 6;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getAvailableRegions(), 10000);

              case 6:
                _context23.t0 = _context23.sent;

                if (_context23.t0) {
                  _context23.next = 9;
                  break;
                }

                _context23.t0 = [];

              case 9:
                this.allRegions = _context23.t0;
                _context23.next = 16;
                break;

              case 12:
                _context23.prev = 12;
                _context23.t1 = _context23["catch"](3);
                console.error('Error getting all regions from Safeture SDK', _context23.t1);
                this.allRegions = [];

              case 16:
                return _context23.abrupt("return", this.allRegions);

              case 17:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[3, 12]]);
      }));

      function getAvailableRegions() {
        return _getAvailableRegions.apply(this, arguments);
      }

      return getAvailableRegions;
    }()
  }, {
    key: "_checkIsInitialized",
    value: function () {
      var _checkIsInitialized2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24() {
        var isRegistered, isSubscribed;
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return window.SafeturePlugin.isRegistered();

              case 2:
                isRegistered = _context24.sent;
                _context24.t0 = isRegistered;

                if (!_context24.t0) {
                  _context24.next = 8;
                  break;
                }

                _context24.next = 7;
                return window.SafeturePlugin.isSubscribed();

              case 7:
                _context24.t0 = _context24.sent;

              case 8:
                isSubscribed = _context24.t0;
                return _context24.abrupt("return", isRegistered && isSubscribed);

              case 10:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function _checkIsInitialized() {
        return _checkIsInitialized2.apply(this, arguments);
      }

      return _checkIsInitialized;
    }()
  }, {
    key: "getFromCache",
    value: function getFromCache(regionsStringified, regionInformationFlags) {
      var ignoreCacheExpirationDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (CACHE[regionsStringified] && CACHE[regionsStringified][regionInformationFlags]) {
        var storedObj = CACHE[regionsStringified][regionInformationFlags];

        if (ignoreCacheExpirationDate || storedObj.date >= (0, _now["default"])() - CACHE_INVALIDATE_TIME) {
          return storedObj.value;
        }
      }

      return null;
    }
  }, {
    key: "savePingUrlOnNative",
    value: function () {
      var _savePingUrlOnNative = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25(pingUrl) {
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                console.log('going to save ping url on native part', pingUrl);

                if (!pingUrl) {
                  _context25.next = 10;
                  break;
                }

                _context25.prev = 2;
                _context25.next = 5;
                return window.SafeturePlugin.savePingUrl(pingUrl);

              case 5:
                _context25.next = 10;
                break;

              case 7:
                _context25.prev = 7;
                _context25.t0 = _context25["catch"](2);
                console.error('error saving ping url in the native code', _context25.t0);

              case 10:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, null, [[2, 7]]);
      }));

      function savePingUrlOnNative(_x8) {
        return _savePingUrlOnNative.apply(this, arguments);
      }

      return savePingUrlOnNative;
    }()
  }, {
    key: "storeInCache",
    value: function storeInCache(regionsStringified, regionInformationFlags, value) {
      if (!CACHE[regionsStringified]) {
        CACHE[regionsStringified] = {};
      }

      CACHE[regionsStringified][regionInformationFlags] = {
        date: (0, _now["default"])(),
        value: value
      };
      this.saveCacheInDataStore();
    }
    /**
     * Returns the region information for the requested regions
     *
     * Consider using getRegionInformation if you only want to request a single region
     * @param regions
     * @param regionInformationFlags
     * @param extraMetadata - will be added after performing the request to every region object
     * @param downloadRegionImages
     * @param ignoreCacheExpirationDate
     * @param waitForInitialized
     * @returns {Promise.<void>}
     */

  }, {
    key: "getRegionsInformation",
    value: function () {
      var _getRegionsInformation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26() {
        var _this2 = this;

        var regions,
            regionInformationFlags,
            extraMetadata,
            downloadRegionImages,
            ignoreCacheExpirationDate,
            waitForInitialized,
            isRetry,
            regionsInfo,
            regionsStringified,
            cachedInfo,
            regionsInfoString,
            imageFilenames,
            _args26 = arguments;
        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                regions = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : [];
                regionInformationFlags = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : REGION_INFORMATION_FLAGS.BASIC;
                extraMetadata = _args26.length > 2 && _args26[2] !== undefined ? _args26[2] : {};
                downloadRegionImages = _args26.length > 3 && _args26[3] !== undefined ? _args26[3] : false;
                ignoreCacheExpirationDate = _args26.length > 4 && _args26[4] !== undefined ? _args26[4] : false;
                waitForInitialized = _args26.length > 5 && _args26[5] !== undefined ? _args26[5] : true;
                isRetry = _args26.length > 6 && _args26[6] !== undefined ? _args26[6] : false;

                if (!waitForInitialized) {
                  _context26.next = 10;
                  break;
                }

                _context26.next = 10;
                return this._waitForInitialized();

              case 10:
                _context26.next = 12;
                return this._lockRegionRequestTurn();

              case 12:
                _context26.prev = 12;
                regionsStringified = (0, _stringify["default"])(regions.sort());
                cachedInfo = this.getFromCache(regionsStringified, regionInformationFlags, ignoreCacheExpirationDate);

                if (!cachedInfo) {
                  _context26.next = 20;
                  break;
                }

                console.log('request for ', regionsStringified, regionInformationFlags, 'is in cache');
                regionsInfo = cachedInfo.slice();
                _context26.next = 34;
                break;

              case 20:
                console.log('request for ', regionsStringified, regionInformationFlags, 'is a new request');
                _context26.prev = 21;
                clearInterval(this.failureRetryInterval);
                _context26.next = 25;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getRegionInformationForRegions(regions, regionInformationFlags), 30000);

              case 25:
                regionsInfoString = _context26.sent;
                _context26.next = 33;
                break;

              case 28:
                _context26.prev = 28;
                _context26.t0 = _context26["catch"](21);

                // regionsInfoString = this.getFromCache(regionsStringified, regionInformationFlags, true)
                if (!isRetry) {
                  this.failureRetryInterval = setInterval(function () {
                    _this2.getRegionsInformation(regions, regionInformationFlags, extraMetadata, downloadRegionImages, false, true, true);
                  }, 10000);
                } // start timer and show message to user that certain data could not be loaded
                else if (!this.failureDialogShownDate || this.failureDialogShownDate < (0, _now["default"])() - FAILURE_DIALOG_REPETITION_TIME) {
                    this.failureDialogShownDate = (0, _now["default"])();
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      html: (0, _strings.getString)('TC_ERROR_UPDATE_SAFETURE_MESSAGE'),
                      extraPaddingAroundCloseButton: true,
                      buttons: [{
                        label: (0, _strings.getString)('OK'),
                        callback: function callback() {}
                      }]
                    });
                    this.failureRetryInterval = setInterval(function () {
                      _this2.getRegionsInformation(regions, regionInformationFlags, extraMetadata, downloadRegionImages, false, true, true);
                    }, 10000);
                  }

                this._unlockRegionRequestTurn();

                return _context26.abrupt("return", _promise["default"].reject(_context26.t0));

              case 33:
                if (regionsInfoString && !(0, _isArray["default"])(regionsInfoString)) {
                  // console.log('regionsInfoString', regionsInfoString)
                  regionsInfo = JSON.parse(regionsInfoString); // regionsInfo = await window.SafeturePlugin.getRegionInformationForRegions(regions, regionInformationFlags)
                  // console.log('regionsInfo', regionsInfo)
                  // console.log('request returned for', regionsStringified)

                  this.storeInCache(regionsStringified, regionInformationFlags, regionsInfo.slice());
                } else if ((0, _isArray["default"])(regionsInfoString)) {
                  regionsInfo = regionsInfoString;
                }

              case 34:
                console.log('regionsInfo', regionsInfo);

                if (!downloadRegionImages) {
                  _context26.next = 41;
                  break;
                }

                _context26.next = 38;
                return this.downloadRegionImages(regions);

              case 38:
                imageFilenames = _context26.sent;
                console.log('downloaded image for country: ', imageFilenames);
                imageFilenames.forEach(function (imageFilename, index) {
                  regionsInfo[index].images = [imageFilename];
                });

              case 41:
                this._addExtraKeys(regionsInfo, extraMetadata);

                this._unlockRegionRequestTurn();

                return _context26.abrupt("return", regionsInfo);

              case 46:
                _context26.prev = 46;
                _context26.t1 = _context26["catch"](12);
                console.error('Error getting current region information from Safeture SDK', _context26.t1);

                this._unlockRegionRequestTurn();

                return _context26.abrupt("return", _promise["default"].reject(_context26.t1));

              case 51:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this, [[12, 46], [21, 28]]);
      }));

      function getRegionsInformation() {
        return _getRegionsInformation.apply(this, arguments);
      }

      return getRegionsInformation;
    }()
    /**
     * Returns the region information for a single region.
     *
     * Consider using getRegionsInformation to request multiple regions at once
     * @param region
     * @param regionInformationFlags
     * @param extraMetadata - will be added after performing the request to every region object
     * @param downloadImage
     * @returns {Promise.<void>}
     */

  }, {
    key: "getRegionInformation",
    value: function () {
      var _getRegionInformation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27() {
        var region,
            regionInformationFlags,
            extraMetadata,
            downloadImage,
            ignoreCacheExpiration,
            information,
            _args27 = arguments;
        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                region = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : null;
                regionInformationFlags = _args27.length > 1 && _args27[1] !== undefined ? _args27[1] : REGION_INFORMATION_FLAGS.BASIC;
                extraMetadata = _args27.length > 2 && _args27[2] !== undefined ? _args27[2] : {};
                downloadImage = _args27.length > 3 && _args27[3] !== undefined ? _args27[3] : false;
                ignoreCacheExpiration = _args27.length > 4 && _args27[4] !== undefined ? _args27[4] : false;
                _context27.next = 7;
                return this._waitForInitialized();

              case 7:
                _context27.prev = 7;

                if (region) {
                  _context27.next = 10;
                  break;
                }

                return _context27.abrupt("return", null);

              case 10:
                _context27.next = 12;
                return this.getRegionsInformation([region], regionInformationFlags, extraMetadata, downloadImage, ignoreCacheExpiration);

              case 12:
                information = _context27.sent;

                if (!(information && information.length > 0)) {
                  _context27.next = 15;
                  break;
                }

                return _context27.abrupt("return", information[0]);

              case 15:
                return _context27.abrupt("return", _promise["default"].reject(new Error("Error getting region information for ".concat(region, ": information is null"))));

              case 18:
                _context27.prev = 18;
                _context27.t0 = _context27["catch"](7);
                console.error("Error getting region information for ".concat(region, " from Safeture SDK"), _context27.t0);
                return _context27.abrupt("return", _promise["default"].reject(_context27.t0));

              case 22:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this, [[7, 18]]);
      }));

      function getRegionInformation() {
        return _getRegionInformation.apply(this, arguments);
      }

      return getRegionInformation;
    }()
  }, {
    key: "getRegionInformationForCurrentRegion",
    value: function () {
      var _getRegionInformationForCurrentRegion = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28() {
        var regionInformationFlags,
            extraMetadata,
            downloadImage,
            ignoreCacheExpiration,
            currentRegion,
            regionInfo,
            _args28 = arguments;
        return _regenerator["default"].wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                regionInformationFlags = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : REGION_INFORMATION_FLAGS.BASIC;
                extraMetadata = _args28.length > 1 && _args28[1] !== undefined ? _args28[1] : {};
                downloadImage = _args28.length > 2 && _args28[2] !== undefined ? _args28[2] : false;
                ignoreCacheExpiration = _args28.length > 3 && _args28[3] !== undefined ? _args28[3] : false;
                _context28.next = 6;
                return this._waitForInitialized();

              case 6:
                _context28.prev = 6;
                _context28.next = 9;
                return this.getCurrentRegion();

              case 9:
                currentRegion = _context28.sent;
                console.log('getRegionInformationForCurrentRegion', currentRegion);

                if (!currentRegion) {
                  _context28.next = 18;
                  break;
                }

                _context28.next = 14;
                return this.getRegionsInformation([currentRegion], regionInformationFlags, extraMetadata, downloadImage, ignoreCacheExpiration);

              case 14:
                regionInfo = _context28.sent;

                if (!(regionInfo.length > 0)) {
                  _context28.next = 18;
                  break;
                }

                if (regionInfo[0].basicInformation) {
                  _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_CURRENT_REGION_CODE, regionInfo[0].basicInformation.isoCode);
                }

                return _context28.abrupt("return", regionInfo[0]);

              case 18:
                return _context28.abrupt("return", null);

              case 21:
                _context28.prev = 21;
                _context28.t0 = _context28["catch"](6);
                console.error('Error getting region information for current region:', _context28.t0);
                return _context28.abrupt("return", _promise["default"].reject(_context28.t0));

              case 25:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this, [[6, 21]]);
      }));

      function getRegionInformationForCurrentRegion() {
        return _getRegionInformationForCurrentRegion.apply(this, arguments);
      }

      return getRegionInformationForCurrentRegion;
    }()
  }, {
    key: "isValidPhoneNumber",
    value: function () {
      var _isValidPhoneNumber = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee29(phoneNumber) {
        return _regenerator["default"].wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (phoneNumber) {
                  _context29.next = 2;
                  break;
                }

                return _context29.abrupt("return", _promise["default"].resolve(false));

              case 2:
                _context29.prev = 2;
                return _context29.abrupt("return", (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.isValidPhoneNumber(phoneNumber), 10000));

              case 6:
                _context29.prev = 6;
                _context29.t0 = _context29["catch"](2);
                console.error('Error finding out whether phone number is valid (via Safeture SDK)', _context29.t0);
                return _context29.abrupt("return", _promise["default"].reject(_context29.t0));

              case 10:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, null, [[2, 6]]);
      }));

      function isValidPhoneNumber(_x9) {
        return _isValidPhoneNumber.apply(this, arguments);
      }

      return isValidPhoneNumber;
    }()
  }, {
    key: "setPhoneNumber",
    value: function () {
      var _setPhoneNumber = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee30(phoneNumber) {
        return _regenerator["default"].wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                _context30.next = 3;
                return window.SafeturePlugin.setPhoneNumber(phoneNumber);

              case 3:
                _context30.next = 9;
                break;

              case 5:
                _context30.prev = 5;
                _context30.t0 = _context30["catch"](0);
                console.error('Error setting phone number in Safeture SDK', _context30.t0);
                return _context30.abrupt("return", _promise["default"].reject(_context30.t0));

              case 9:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, null, [[0, 5]]);
      }));

      function setPhoneNumber(_x10) {
        return _setPhoneNumber.apply(this, arguments);
      }

      return setPhoneNumber;
    }()
  }, {
    key: "getAvailableLanguages",
    value: function () {
      var _getAvailableLanguages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee31() {
        return _regenerator["default"].wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this._waitForInitialized();

              case 2:
                _context31.prev = 2;
                _context31.next = 5;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getAvailableLanguages(), 10000);

              case 5:
                return _context31.abrupt("return", _context31.sent);

              case 8:
                _context31.prev = 8;
                _context31.t0 = _context31["catch"](2);
                console.error('Error getting available messages from Safeture SDK', _context31.t0);
                return _context31.abrupt("return", _promise["default"].reject(_context31.t0));

              case 12:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this, [[2, 8]]);
      }));

      function getAvailableLanguages() {
        return _getAvailableLanguages.apply(this, arguments);
      }

      return getAvailableLanguages;
    }()
  }, {
    key: "getAvailableCurrencies",
    value: function () {
      var _getAvailableCurrencies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee32() {
        return _regenerator["default"].wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this._waitForInitialized();

              case 2:
                _context32.prev = 2;
                _context32.next = 5;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getAvailableCurrencies(_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE)), 10000);

              case 5:
                return _context32.abrupt("return", _context32.sent);

              case 8:
                _context32.prev = 8;
                _context32.t0 = _context32["catch"](2);
                console.error('Error getting available currencies from Safeture SDK', _context32.t0);
                return _context32.abrupt("return", _promise["default"].reject(_context32.t0));

              case 12:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this, [[2, 8]]);
      }));

      function getAvailableCurrencies() {
        return _getAvailableCurrencies.apply(this, arguments);
      }

      return getAvailableCurrencies;
    }()
  }, {
    key: "convertCurrency",
    value: function () {
      var _convertCurrency = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee33(from, to, amount) {
        return _regenerator["default"].wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this._waitForInitialized();

              case 2:
                _context33.prev = 2;
                _context33.next = 5;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.convertCurrency(from, to, amount), 10000);

              case 5:
                return _context33.abrupt("return", _context33.sent);

              case 8:
                _context33.prev = 8;
                _context33.t0 = _context33["catch"](2);
                console.error('Error getting available currencies from Safeture SDK', _context33.t0);
                return _context33.abrupt("return", _promise["default"].reject(_context33.t0));

              case 12:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this, [[2, 8]]);
      }));

      function convertCurrency(_x11, _x12, _x13) {
        return _convertCurrency.apply(this, arguments);
      }

      return convertCurrency;
    }()
  }, {
    key: "getConfig",
    value: function () {
      var _getConfig = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee34() {
        return _regenerator["default"].wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this._waitForInitialized();

              case 2:
                _context34.prev = 2;
                _context34.next = 5;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getConfiguration(), 10000);

              case 5:
                return _context34.abrupt("return", _context34.sent);

              case 8:
                _context34.prev = 8;
                _context34.t0 = _context34["catch"](2);
                console.error('Error getting config from Safeture SDK', _context34.t0);
                return _context34.abrupt("return", _promise["default"].reject(_context34.t0));

              case 12:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this, [[2, 8]]);
      }));

      function getConfig() {
        return _getConfig.apply(this, arguments);
      }

      return getConfig;
    }()
  }, {
    key: "setConfig",
    value: function () {
      var _setConfig = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee35(config) {
        return _regenerator["default"].wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this._waitForInitialized();

              case 2:
                _context35.next = 4;
                return this._lockConfigWriteTurn();

              case 4:
                console.log('setting config', config);
                _context35.prev = 5;
                _context35.next = 8;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.setConfiguration(config), 15000);

              case 8:
                this._unlockConfigWriteTurn();

                _context35.next = 16;
                break;

              case 11:
                _context35.prev = 11;
                _context35.t0 = _context35["catch"](5);
                console.error('Error setting config in Safeture.js or Safeture SDK', _context35.t0);

                this._unlockConfigWriteTurn();

                return _context35.abrupt("return", _promise["default"].reject(_context35.t0));

              case 16:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this, [[5, 11]]);
      }));

      function setConfig(_x14) {
        return _setConfig.apply(this, arguments);
      }

      return setConfig;
    }()
  }, {
    key: "setLanguage",
    value: function () {
      var _setLanguage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee36(languageCode) {
        var availableLanguages, bestAlternativeCode, bestLanguage, config;
        return _regenerator["default"].wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                console.log('input Safeture setLanguage', languageCode, this.initializedListeners);
                _context36.next = 3;
                return this._waitForInitialized();

              case 3:
                _context36.prev = 3;
                _context36.next = 6;
                return this.getAvailableLanguages();

              case 6:
                availableLanguages = _context36.sent;
                bestAlternativeCode = null;
                bestLanguage = availableLanguages.find(function (language) {
                  if (language.code.startsWith(languageCode)) {
                    if (!language.isNative) {
                      return true;
                    }

                    bestAlternativeCode = language.code;
                  }
                });
                console.log('input', languageCode, bestLanguage, bestAlternativeCode);

                if (!(bestLanguage || bestAlternativeCode)) {
                  _context36.next = 19;
                  break;
                }

                config = {
                  preferredLanguage: bestLanguage ? bestLanguage.code : bestAlternativeCode,
                  translationMethod: TRANSLATION_METHOD.ALLOW_MACHINE // enables push messages in user langugage

                };
                _context36.next = 14;
                return this.setConfig(config);

              case 14:
                // force reload of data because new language is set
                this.invalidateCache();
                this.saveCacheInDataStore();
                return _context36.abrupt("return");

              case 19:
                if (!(languageCode.length > 2)) {
                  _context36.next = 21;
                  break;
                }

                return _context36.abrupt("return", this.setLanguage(languageCode.substring(0, 2)));

              case 21:
                return _context36.abrupt("return", _promise["default"].reject(new Error("preferred language code not available in Safeture SDK. Available codes are: ".concat((0, _stringify["default"])(availableLanguages)))));

              case 24:
                _context36.prev = 24;
                _context36.t0 = _context36["catch"](3);
                console.error('Error setting language in Safeture.js or Safeture SDK', _context36.t0);
                return _context36.abrupt("return", _promise["default"].reject(_context36.t0));

              case 28:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this, [[3, 24]]);
      }));

      function setLanguage(_x15) {
        return _setLanguage.apply(this, arguments);
      }

      return setLanguage;
    }()
  }, {
    key: "isBatteryOptimized",
    value: function () {
      var _isBatteryOptimized = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee37() {
        var isBatteryOptimized;
        return _regenerator["default"].wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.next = 2;
                return window.SafeturePlugin.isBatteryOptimized();

              case 2:
                isBatteryOptimized = _context37.sent;
                return _context37.abrupt("return", isBatteryOptimized === 1 || isBatteryOptimized === true);

              case 4:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37);
      }));

      function isBatteryOptimized() {
        return _isBatteryOptimized.apply(this, arguments);
      }

      return isBatteryOptimized;
    }()
  }, {
    key: "validatePhoneNumberWithCode",
    value: function () {
      var _validatePhoneNumberWithCode = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee38(validationCode) {
        return _regenerator["default"].wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                _context38.prev = 0;
                _context38.next = 3;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.validatePhoneNumberWithCode(validationCode), 10000);

              case 3:
                _context38.next = 9;
                break;

              case 5:
                _context38.prev = 5;
                _context38.t0 = _context38["catch"](0);
                console.error('Error validating phone number in Safeture SDK', _context38.t0);
                return _context38.abrupt("return", _promise["default"].reject(_context38.t0));

              case 9:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, null, [[0, 5]]);
      }));

      function validatePhoneNumberWithCode(_x16) {
        return _validatePhoneNumberWithCode.apply(this, arguments);
      }

      return validatePhoneNumberWithCode;
    }()
    /**
     *
     * @param title The title
     * @param message The message
     * @param alertId Same id given in multiple calls replaces the original alert
     * @param data This data is given to the app when the alert is tapped
     * @returns {Promise<never>}
     */

  }, {
    key: "showAndroidNotification",
    value: function () {
      var _showAndroidNotification = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee39(title, message, alertId, data) {
        return _regenerator["default"].wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.prev = 0;
                _context39.next = 3;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.showAndroidNotification(title, message, alertId, data), 10000);

              case 3:
                _context39.next = 9;
                break;

              case 5:
                _context39.prev = 5;
                _context39.t0 = _context39["catch"](0);
                console.error('Error showing android notification via SDK', _context39.t0);
                return _context39.abrupt("return", _promise["default"].reject(_context39.t0));

              case 9:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, null, [[0, 5]]);
      }));

      function showAndroidNotification(_x17, _x18, _x19, _x20) {
        return _showAndroidNotification.apply(this, arguments);
      }

      return showAndroidNotification;
    }()
  }, {
    key: "getOldTravelAndCareData",
    value: function () {
      var _getOldTravelAndCareData = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee40() {
        return _regenerator["default"].wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                _context40.prev = 0;
                return _context40.abrupt("return", (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.getOldTravelAndCareData(), 10000));

              case 4:
                _context40.prev = 4;
                _context40.t0 = _context40["catch"](0);
                console.error('Error getting old travel and care data', _context40.t0);
                return _context40.abrupt("return", _promise["default"].resolve(null));

              case 8:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, null, [[0, 4]]);
      }));

      function getOldTravelAndCareData() {
        return _getOldTravelAndCareData.apply(this, arguments);
      }

      return getOldTravelAndCareData;
    }()
    /**
     * This function must be called after successful registration and subscription
     * @returns {Promise<void>}
     */

  }, {
    key: "migratePhoneNumberAndRegisterPolicyNumberFromOldApp",
    value: function () {
      var _migratePhoneNumberAndRegisterPolicyNumberFromOldApp = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee41() {
        var dataToSet, oldPhoneNumber, isValidated;
        return _regenerator["default"].wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                dataToSet = {};
                dataToSet[_DataStore.DATA_STORE_PATHS.TC_SAFETURE_PHONE_NUMBER_MIGRATED] = true;
                _context41.prev = 2;
                _context41.next = 5;
                return window.SafeturePlugin.migratePhoneNumber();

              case 5:
                oldPhoneNumber = _context41.sent;
                _context41.next = 8;
                return window.SafeturePlugin.isValidated();

              case 8:
                isValidated = _context41.sent;

                if (!(oldPhoneNumber && oldPhoneNumber !== 'OK')) {
                  _context41.next = 14;
                  break;
                }

                dataToSet[_DataStore.DATA_STORE_PATHS.TC_PHONE_NUMBER] = oldPhoneNumber;

                if (!(this.policyNumberToUseAfterPhoneNumberMigration && this.homeRegionToUseAfterPhoneNumberMigration)) {
                  _context41.next = 14;
                  break;
                }

                _context41.next = 14;
                return this.savePolicyNumberAfterUpgradeFromOldApp(this.homeRegionToUseAfterPhoneNumberMigration, this.policyNumberToUseAfterPhoneNumberMigration, oldPhoneNumber);

              case 14:
                _context41.next = 19;
                break;

              case 16:
                _context41.prev = 16;
                _context41.t0 = _context41["catch"](2);
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: 'Error migrating the old phone number',
                  message: _context41.t0.message
                });

              case 19:
                _context41.next = 21;
                return _DataStore["default"].setData(dataToSet);

              case 21:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this, [[2, 16]]);
      }));

      function migratePhoneNumberAndRegisterPolicyNumberFromOldApp() {
        return _migratePhoneNumberAndRegisterPolicyNumberFromOldApp.apply(this, arguments);
      }

      return migratePhoneNumberAndRegisterPolicyNumberFromOldApp;
    }()
  }, {
    key: "migrateDataFromOldApp",
    value: function () {
      var _migrateDataFromOldApp = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee42() {
        var dataToSet, oldData, enableService, newConfig, privacyData, policyData, homeRegion, policyNumber;
        return _regenerator["default"].wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.next = 2;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_DATA_MIGRATED);

              case 2:
                if (_context42.sent) {
                  _context42.next = 17;
                  break;
                }

                dataToSet = {};
                dataToSet[_DataStore.DATA_STORE_PATHS.TC_SAFETURE_DATA_MIGRATED] = true;
                _context42.prev = 5;
                _context42.next = 8;
                return this.getOldTravelAndCareData();

              case 8:
                oldData = _context42.sent;

                // showMuiAlertWithOptions({
                //   title: 'Alte Daten:',
                //   message: JSON.stringify(oldData)
                // })
                if (oldData) {
                  dataToSet[_DataStore.DATA_STORE_PATHS.TC_PRIVACY_ACCEPTED] = false;
                  dataToSet[_DataStore.DATA_STORE_PATHS.TC_SAFETURE_RECEIVER_KEY] = oldData['receiverKey'];
                  dataToSet[_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE] = oldData['appLanguage'];
                  enableService = oldData['enableService'];
                  newConfig = {};

                  if (enableService === false || enableService === 'false') {
                    newConfig[CONFIG_KEYS.SERVICE_ENABLED] = 0;
                  }

                  privacyData = oldData['privacyData'];

                  if (privacyData === true || privacyData === 'true') {
                    newConfig[CONFIG_KEYS.TRACKING_METHOD] = TRACKING_METHOD.REGION;
                  }

                  this.setConfig(newConfig);

                  if (oldData['policyData']) {
                    policyData = JSON.parse(oldData['policyData']);
                    homeRegion = policyData['countryCode'];
                    policyNumber = policyData['policyNumber'];
                    dataToSet[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE] = homeRegion;
                    dataToSet[_DataStore.DATA_STORE_PATHS.TC_MIGRATED_POLICY_NUMBER] = policyNumber;
                    this.homeRegionToUseAfterPhoneNumberMigration = homeRegion;
                    this.policyNumberToUseAfterPhoneNumberMigration = policyNumber;
                  }
                }

                _context42.next = 15;
                break;

              case 12:
                _context42.prev = 12;
                _context42.t0 = _context42["catch"](5);
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: (0, _strings.getString)('ERROR'),
                  message: _context42.t0.message
                });

              case 15:
                _context42.next = 17;
                return _DataStore["default"].setData(dataToSet);

              case 17:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this, [[5, 12]]);
      }));

      function migrateDataFromOldApp() {
        return _migrateDataFromOldApp.apply(this, arguments);
      }

      return migrateDataFromOldApp;
    }()
  }, {
    key: "register",
    value: function () {
      var _register2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee43() {
        var keysFromDataStore;
        return _regenerator["default"].wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return _DataStore["default"].getElementByPath(_DataStore.DATA_STORE_PATHS.TC_SAFETURE_KEYS);

              case 2:
                keysFromDataStore = _context43.sent;
                _context43.next = 5;
                return this._register(keysFromDataStore.API_KEY_CUSTOMER);

              case 5:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function register() {
        return _register2.apply(this, arguments);
      }

      return register;
    }() // ------------------------------------------------------------
    // INTERNAL HELPER FUNCTIONS
    // ------------------------------------------------------------

  }, {
    key: "_initListeners",
    value: function _initListeners() {
      var _this3 = this;

      (0, _ResumeSuspendListeners.addOnResumeListener)(function () {
        if (window.SafeturePlugin) {
          window.SafeturePlugin.onResume();
        }

        _this3.getCurrentRegion();
      });
      window.SafeturePlugin.onNewRegion = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee44() {
        var newRegion;
        return _regenerator["default"].wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                (0, _LogService.pushTravelAndCareLogMessage)('newRegionEvent'); // new region entered, let's find out which one

                _context44.next = 3;
                return _this3.getCurrentRegion();

              case 3:
                newRegion = _context44.sent;

                _this3.checkIfIsNewRegion(newRegion);

              case 5:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));

      this._pollCurrentRegionUntilAvailable();
    }
  }, {
    key: "checkIfIsNewRegion",
    value: function checkIfIsNewRegion(newRegion) {
      var lastNotifiedRegion = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_DOCUMENTSAFE_LAST_NOTIFIED_REGION);

      if (lastNotifiedRegion && newRegion && lastNotifiedRegion !== newRegion) {
        (0, _LogService.pushTravelAndCareLogMessage)('detectedRegionChange', {
          newRegion: newRegion,
          oldRegion: lastNotifiedRegion
        });
        (0, _MuiAlertHelper.showAlert)((0, _strings.getString)('TC_REGION_CHANGE', [_config["default"].tcCountryHelper.getTranslatedCountryNameByName(newRegion)]));

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_DOCUMENTSAFE_LAST_NOTIFIED_REGION, newRegion);
      }
    }
  }, {
    key: "_pollCurrentRegionUntilAvailable",
    value: function () {
      var _pollCurrentRegionUntilAvailable2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee45() {
        var waitTime,
            _args45 = arguments;
        return _regenerator["default"].wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                waitTime = _args45.length > 0 && _args45[0] !== undefined ? _args45[0] : 0;

                if (this.currentRegion) {
                  _context45.next = 7;
                  break;
                }

                _context45.next = 4;
                return this.getCurrentRegion();

              case 4:
                _context45.next = 6;
                return (0, _TimeoutHelper.timeout)(Math.pow(2, waitTime) * 100);

              case 6:
                this._pollCurrentRegionUntilAvailable(waitTime < 8 ? waitTime + 1 : waitTime);

              case 7:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function _pollCurrentRegionUntilAvailable() {
        return _pollCurrentRegionUntilAvailable2.apply(this, arguments);
      }

      return _pollCurrentRegionUntilAvailable;
    }()
  }, {
    key: "_register",
    value: function () {
      var _register3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee46(apiKey) {
        var isRegistered;
        return _regenerator["default"].wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                if (!window.SafeturePlugin) {
                  _context46.next = 14;
                  break;
                }

                _context46.next = 3;
                return window.SafeturePlugin.isRegistered();

              case 3:
                isRegistered = _context46.sent;

                if (isRegistered) {
                  _context46.next = 14;
                  break;
                }

                _context46.prev = 5;
                _context46.next = 8;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.registerWithKey(apiKey), 30000);

              case 8:
                _context46.next = 14;
                break;

              case 10:
                _context46.prev = 10;
                _context46.t0 = _context46["catch"](5);
                console.error('error registering at Safeture', _context46.t0); // showWideAlertHtml(getErrorMessage(error), getString('FAILURE'))

                return _context46.abrupt("return", _promise["default"].reject(_context46.t0));

              case 14:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, null, [[5, 10]]);
      }));

      function _register(_x21) {
        return _register3.apply(this, arguments);
      }

      return _register;
    }()
  }, {
    key: "showInfoAboutMissingPermissions",
    value: function () {
      var _showInfoAboutMissingPermissions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee49(missingPermissions) {
        var _this4 = this;

        var tries,
            resolveFn,
            phonePermission,
            locationPermission,
            backgroundPermission,
            hideDialog,
            settingsButton,
            locationCancelButton,
            phoneCancelButton,
            androidVersion,
            button,
            _args49 = arguments;
        return _regenerator["default"].wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                tries = _args49.length > 1 && _args49[1] !== undefined ? _args49[1] : 0;
                resolveFn = _args49.length > 2 ? _args49[2] : undefined;
                phonePermission = 'android.permission.READ_PHONE_STATE';
                locationPermission = 'android.permission.ACCESS_FINE_LOCATION';
                backgroundPermission = 'android.permission.ACCESS_BACKGROUND_LOCATION';
                settingsButton = {
                  callback: function callback() {
                    if (hideDialog) hideDialog();
                    window.cordova.plugins.settings.open('application_details', function () {
                      console.log('opened settings on android');
                    }, function () {
                      console.log('failed to open settings on android');
                    });
                  },
                  label: (0, _strings.getString)('TC_PERMISSIONS_INFO_SETTINGS_BUTTON')
                };
                locationCancelButton = {
                  callback: missingPermissions.length > 1 ? function () {
                    resolveFn ? resolveFn() : null;
                  } : function () {
                    _this4.initInProgress = false;

                    _this4._init();
                  },
                  label: (0, _strings.getString)('TC_PERMISSIONS_INFO_LOCATION_CANCEL_BUTTON')
                };

                if (missingPermissions.indexOf(locationPermission) !== -1) {
                  this.alreadyShownLocationWarning = true;
                  setTimeout( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee47() {
                    var hibernationState, html;
                    return _regenerator["default"].wrap(function _callee47$(_context47) {
                      while (1) {
                        switch (_context47.prev = _context47.next) {
                          case 0:
                            _context47.next = 2;
                            return _this4.checkIfHibernationModeActive(true);

                          case 2:
                            hibernationState = _context47.sent;
                            html = hibernationState === HIBERNATION_MODE_STATES.ACTIVE ? (0, _strings.getString)('TC_PERMISSIONS_INFO_LOCATION_TEXT_W_HIBERNATE') : (0, _strings.getString)('TC_PERMISSIONS_INFO_LOCATION_TEXT');
                            return _context47.abrupt("return", (0, _MuiAlertHelper.showAlertWithOptions)({
                              title: (0, _strings.getString)('TC_PERMISSIONS_INFO_LOCATION_TITLE'),
                              html: html,
                              severity: _MuiAlertHelper.SEVERITIES.HIGH,
                              buttons: [locationCancelButton, settingsButton],
                              showCloseButton: false
                            }));

                          case 5:
                          case "end":
                            return _context47.stop();
                        }
                      }
                    }, _callee47);
                  })));
                }

                phoneCancelButton = {
                  callback: function callback() {
                    _this4.initInProgress = false;

                    _this4._init();
                  },
                  label: (0, _strings.getString)('TC_PERMISSIONS_INFO_PHONE_CANCEL_BUTTON')
                };

                if (missingPermissions.indexOf(phonePermission) !== -1) {
                  setTimeout(function () {
                    return (0, _MuiAlertHelper.showAlertWithOptions)({
                      title: (0, _strings.getString)('TC_PERMISSIONS_INFO_PHONE_TITLE'),
                      html: (0, _strings.getString)('TC_PERMISSIONS_INFO_PHONE_TEXT'),
                      severity: _MuiAlertHelper.SEVERITIES.HIGH,
                      buttons: [phoneCancelButton, settingsButton],
                      showCloseButton: false
                    });
                  });
                }

                androidVersion = _DeviceInfoHelper["default"].getAndroidVersion();

                if (missingPermissions.indexOf(backgroundPermission) !== -1 && missingPermissions.length === 1) {
                  // make sure that we already asked for the foreground location before asking before the background one
                  // we have to ask twice on android -> once for foreground location and once again for background location
                  button = {
                    callback: function () {
                      var _callback5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee48() {
                        var askedBackgroundBefore, permissions;
                        return _regenerator["default"].wrap(function _callee48$(_context48) {
                          while (1) {
                            switch (_context48.prev = _context48.next) {
                              case 0:
                                _context48.prev = 0;
                                askedBackgroundBefore = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BACKGROUND_BEFORE);

                                if (!askedBackgroundBefore) {
                                  _context48.next = 6;
                                  break;
                                }

                                hideDialog();
                                _context48.next = 10;
                                break;

                              case 6:
                                _context48.next = 8;
                                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BACKGROUND_BEFORE, true);

                              case 8:
                                _context48.next = 10;
                                return window.SafeturePlugin.requestPermissions();

                              case 10:
                                _context48.next = 18;
                                break;

                              case 12:
                                _context48.prev = 12;
                                _context48.t0 = _context48["catch"](0);
                                _context48.next = 16;
                                return _this4.checkPermissions();

                              case 16:
                                permissions = _context48.sent;

                                // again and again and again
                                if (permissions && permissions.missing && permissions.missing.length === 0) {
                                  hideDialog();
                                } else {
                                  setTimeout(function () {
                                    _this4.initInProgress = false;

                                    _this4._init();
                                  });
                                }

                              case 18:
                              case "end":
                                return _context48.stop();
                            }
                          }
                        }, _callee48, null, [[0, 12]]);
                      }));

                      function callback() {
                        return _callback5.apply(this, arguments);
                      }

                      return callback;
                    }(),
                    label: (0, _strings.getString)('OK')
                  };

                  if (!hideDialog) {
                    setTimeout(function () {
                      hideDialog = (0, _MuiAlertHelper.showAlertWithOptions)({
                        title: (0, _strings.getString)('TC_EXPLANATION_BACKGROUND_LOCATION_TITLE'),
                        html: (0, _strings.getString)('TC_EXPLANATION_BACKGROUND_LOCATION_MESSAGE'),
                        severity: _MuiAlertHelper.SEVERITIES.HIGH,
                        buttons: [button],
                        showCloseButton: false
                      });
                    }, 0);
                  }
                }

              case 12:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function showInfoAboutMissingPermissions(_x22) {
        return _showInfoAboutMissingPermissions.apply(this, arguments);
      }

      return showInfoAboutMissingPermissions;
    }()
  }, {
    key: "checkPermissions",
    value: function () {
      var _checkPermissions = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee50() {
        var askedBefore;
        return _regenerator["default"].wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.prev = 0;
                askedBefore = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BEFORE);

                if (askedBefore) {
                  _context50.next = 4;
                  break;
                }

                return _context50.abrupt("return");

              case 4:
                return _context50.abrupt("return", window.SafeturePlugin.checkPermissions());

              case 7:
                _context50.prev = 7;
                _context50.t0 = _context50["catch"](0);
                console.error('error checking permissions');

              case 10:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, null, [[0, 7]]);
      }));

      function checkPermissions() {
        return _checkPermissions.apply(this, arguments);
      }

      return checkPermissions;
    }()
  }, {
    key: "_subscribe",
    value: function () {
      var _subscribe2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee51(subscriptionKey) {
        return _regenerator["default"].wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                if (!window.SafeturePlugin) {
                  _context51.next = 12;
                  break;
                }

                _context51.prev = 1;
                _context51.next = 4;
                return (0, _PromiseHelper.timeoutPromise)(window.SafeturePlugin.subscribeWithKey(subscriptionKey), 30000);

              case 4:
                _context51.next = 12;
                break;

              case 6:
                _context51.prev = 6;
                _context51.t0 = _context51["catch"](1);
                console.error('error subscribing at Safeture', _context51.t0); // DO NOT TRY TO SUBSCRIBE TWICE TO TRIAL -> WILL GIVE FOLLOWING ERROR

                if (!(_context51.t0.code === 'TRIAL_SUBSCRIPTION_NOT_ALLOWED')) {
                  _context51.next = 11;
                  break;
                }

                return _context51.abrupt("return", _promise["default"].resolve());

              case 11:
                return _context51.abrupt("return", _promise["default"].reject(_context51.t0));

              case 12:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, null, [[1, 6]]);
      }));

      function _subscribe(_x23) {
        return _subscribe2.apply(this, arguments);
      }

      return _subscribe;
    }()
  }, {
    key: "_requestPermissions",
    value: function () {
      var _requestPermissions2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee54() {
        var _this5 = this;

        var storedLanguage;
        return _regenerator["default"].wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                if (!window.SafeturePlugin) {
                  _context54.next = 19;
                  break;
                }

                _context54.prev = 1;

                if (!_DeviceInfoHelper["default"].isiOS()) {
                  _context54.next = 7;
                  break;
                }

                if (_DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BEFORE)) {
                  _context54.next = 5;
                  break;
                }

                return _context54.abrupt("return", new _promise["default"](function (resolve, reject) {
                  var button = {
                    callback: function callback() {
                      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BEFORE, true);

                      window.SafeturePlugin.requestPermissions();
                      setTimeout(function () {
                        return resolve();
                      }, 2000);
                    },
                    label: (0, _strings.getString)('OK')
                  };
                  (0, _MuiAlertHelper.showAlertWithOptions)({
                    title: (0, _strings.getString)('TC_EXPLANATION_BACKGROUND_ACTIVITY_TITLE'),
                    html: (0, _strings.getString)('TC_EXPLANATION_BACKGROUND_ACTIVITY_MESSAGE'),
                    severity: _MuiAlertHelper.SEVERITIES.HIGH,
                    buttons: [button],
                    showCloseButton: false
                  });
                }));

              case 5:
                _context54.next = 12;
                break;

              case 7:
                // Android
                // const isOptimized = await this.isBatteryOptimized()
                storedLanguage = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_LANGUAGE);

                if (!(storedLanguage && storedLanguage.languageCode)) {
                  _context54.next = 11;
                  break;
                }

                _context54.next = 11;
                return (0, _strings.setCurrentLanguage)(storedLanguage.languageCode);

              case 11:
                return _context54.abrupt("return", new _promise["default"]( /*#__PURE__*/function () {
                  var _ref15 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee53(resolve, reject) {
                    var askedBefore, permissions, backgroundAskedBefore, button, messageText, androidVersion;
                    return _regenerator["default"].wrap(function _callee53$(_context53) {
                      while (1) {
                        switch (_context53.prev = _context53.next) {
                          case 0:
                            askedBefore = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BEFORE);

                            if (!askedBefore) {
                              _context53.next = 8;
                              break;
                            }

                            _context53.next = 4;
                            return _this5.checkPermissions();

                          case 4:
                            permissions = _context53.sent;

                            if (permissions && (permissions.missing && permissions.missing.length === 0 || permissions === 'OK')) {
                              resolve();
                            } else if (_DeviceInfoHelper["default"].isAndroid() && permissions && permissions.missing && permissions.missing.length > 0) {
                              backgroundAskedBefore = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BACKGROUND_BEFORE);
                              console.log('checkPermissions after asking for permissions (should only be shown after init) with missing permissions', permissions, backgroundAskedBefore);

                              if (permissions.missing.length === 1 && permissions.missing[0] === 'android.permission.ACCESS_BACKGROUND_LOCATION' && backgroundAskedBefore) {
                                resolve();
                              } else {
                                if (_this5.alreadyShownLocationWarning) {
                                  resolve();
                                } else {
                                  setTimeout(function () {
                                    _this5.showInfoAboutMissingPermissions(permissions.missing, 0, resolve);
                                  }, 0);
                                }
                              }
                            }

                            _context53.next = 14;
                            break;

                          case 8:
                            button = {
                              callback: function () {
                                var _callback6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee52() {
                                  var _permissions;

                                  return _regenerator["default"].wrap(function _callee52$(_context52) {
                                    while (1) {
                                      switch (_context52.prev = _context52.next) {
                                        case 0:
                                          _context52.prev = 0;
                                          _context52.next = 3;
                                          return window.SafeturePlugin.requestPermissions();

                                        case 3:
                                          _context52.next = 5;
                                          return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BEFORE, true);

                                        case 5:
                                          resolve();
                                          _context52.next = 16;
                                          break;

                                        case 8:
                                          _context52.prev = 8;
                                          _context52.t0 = _context52["catch"](0);
                                          _context52.next = 12;
                                          return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_PERMISSIONS_ASKED_BEFORE, true);

                                        case 12:
                                          _context52.next = 14;
                                          return _this5.checkPermissions();

                                        case 14:
                                          _permissions = _context52.sent;

                                          // again and again and again
                                          if (_permissions && _permissions.missing && _permissions.missing.length === 0) {
                                            resolve();
                                          } else {
                                            if (_this5.alreadyShownLocationWarning) {
                                              resolve();
                                            } else {
                                              setTimeout(function () {
                                                _this5.showInfoAboutMissingPermissions(_permissions.missing, 0, resolve);
                                              }, 0);
                                            }
                                          }

                                        case 16:
                                        case "end":
                                          return _context52.stop();
                                      }
                                    }
                                  }, _callee52, null, [[0, 8]]);
                                }));

                                function callback() {
                                  return _callback6.apply(this, arguments);
                                }

                                return callback;
                              }(),
                              label: (0, _strings.getString)('OK')
                            };
                            messageText = (0, _strings.getString)('TC_EXPLANATION_PHONE_CALL_MESSAGE_OLD');
                            androidVersion = _DeviceInfoHelper["default"].getAndroidVersion();

                            if (androidVersion && (0, _parseInt2["default"])(androidVersion) >= 11) {
                              messageText = (0, _strings.getString)('TC_EXPLANATION_PHONE_CALL_MESSAGE_A11');
                            } else if (androidVersion && (0, _parseInt2["default"])(androidVersion) === 10) {
                              messageText = (0, _strings.getString)('TC_EXPLANATION_PHONE_CALL_MESSAGE');
                            }

                            console.log('androidVersion', androidVersion);
                            (0, _MuiAlertHelper.showAlertWithOptions)({
                              title: (0, _strings.getString)('TC_EXPLANATION_PHONE_CALL_TITLE'),
                              html: messageText,
                              severity: _MuiAlertHelper.SEVERITIES.HIGH,
                              buttons: [button],
                              showCloseButton: false
                            });

                          case 14:
                          case "end":
                            return _context53.stop();
                        }
                      }
                    }, _callee53);
                  }));

                  return function (_x24, _x25) {
                    return _ref15.apply(this, arguments);
                  };
                }()));

              case 12:
                _context54.next = 17;
                break;

              case 14:
                _context54.prev = 14;
                _context54.t0 = _context54["catch"](1);
                console.error('error requesting permissions in Safeture.js or Safeture SDK:', _context54.t0);

              case 17:
                _context54.next = 20;
                break;

              case 19:
                console.error('error requesting permissions in Safeture: no Safeture plugin available');

              case 20:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, null, [[1, 14]]);
      }));

      function _requestPermissions() {
        return _requestPermissions2.apply(this, arguments);
      }

      return _requestPermissions;
    }()
  }, {
    key: "invalidateCache",
    value: function invalidateCache() {
      CACHE = {}; // do not call saveCacheInDataStore here
    }
  }, {
    key: "saveCacheInDataStore",
    value: function saveCacheInDataStore() {
      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.TC_REGION_INFO_CACHE, CACHE);
    }
  }, {
    key: "_addExtraKeys",
    value: function _addExtraKeys(regionsInfo, extraMetadata) {
      var extraKeys = (0, _keys["default"])(extraMetadata);
      regionsInfo.forEach(function (region) {
        extraKeys.forEach(function (key) {
          region[key] = extraMetadata[key];
        });
      });
    }
  }, {
    key: "_waitForInitialized",
    value: function () {
      var _waitForInitialized2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee55() {
        var _this6 = this;

        var userRole;
        return _regenerator["default"].wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                userRole = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_USER_ROLE);

                if (!(userRole === REGISTER_STATUS.UNREGISTERED)) {
                  _context55.next = 4;
                  break;
                }

                console.log('do not wait for init -> wont come because user is not initialized');
                throw new Error('User is unregistered');

              case 4:
                if (!this.isInitialized) {
                  _context55.next = 8;
                  break;
                }

                return _context55.abrupt("return", _promise["default"].resolve());

              case 8:
                // TODO: To be discussed...
                if (!this.isInitialized && !this.initInProgress) {
                  console.log('safeture not initialized and not in init');
                  this.init();
                }

              case 9:
                return _context55.abrupt("return", new _promise["default"](function (resolve, reject) {
                  _this6.initializedListeners.push(resolve);
                }));

              case 10:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function _waitForInitialized() {
        return _waitForInitialized2.apply(this, arguments);
      }

      return _waitForInitialized;
    }()
  }, {
    key: "_lockRegionRequestTurn",
    value: function () {
      var _lockRegionRequestTurn2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee56() {
        var _this7 = this;

        return _regenerator["default"].wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                return _context56.abrupt("return", new _promise["default"](function (resolve, reject) {
                  if (_this7.isRequestingRegionInformation) {
                    _this7.regionRequestQueue.push(resolve);

                    return;
                  }

                  _this7.isRequestingRegionInformation = true;
                  resolve();
                }));

              case 1:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56);
      }));

      function _lockRegionRequestTurn() {
        return _lockRegionRequestTurn2.apply(this, arguments);
      }

      return _lockRegionRequestTurn;
    }()
    /**
     * Will call the next in queue after setTimeout()
     * @private
     */

  }, {
    key: "_unlockRegionRequestTurn",
    value: function _unlockRegionRequestTurn() {
      if (this.regionRequestQueue.length > 0) {
        var nextInQueue = this.regionRequestQueue[0];
        (0, _ArrayHelper.removeElementAtPosition)(this.regionRequestQueue, 0);
        setTimeout(function () {
          nextInQueue();
        });
      } else {
        this.isRequestingRegionInformation = false;
      }
    }
  }, {
    key: "_lockConfigWriteTurn",
    value: function () {
      var _lockConfigWriteTurn2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee57() {
        var _this8 = this;

        return _regenerator["default"].wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                return _context57.abrupt("return", new _promise["default"](function (resolve, reject) {
                  if (_this8.isWritingConfig) {
                    _this8.configWriteQueue.push(resolve);

                    return;
                  }

                  _this8.isWritingConfig = true;
                  resolve();
                }));

              case 1:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57);
      }));

      function _lockConfigWriteTurn() {
        return _lockConfigWriteTurn2.apply(this, arguments);
      }

      return _lockConfigWriteTurn;
    }()
    /**
     * Will call the next in queue after setTimeout()
     * @private
     */

  }, {
    key: "_unlockConfigWriteTurn",
    value: function _unlockConfigWriteTurn() {
      if (this.configWriteQueue.length > 0) {
        var nextInQueue = this.configWriteQueue[0];
        (0, _ArrayHelper.removeElementAtPosition)(this.configWriteQueue, 0);
        setTimeout(function () {
          nextInQueue();
        });
      } else {
        this.isWritingConfig = false;
      }
    } // b64toBlob(b64Data, contentType, sliceSize) {
    //   contentType = contentType || '';
    //   sliceSize = sliceSize || 512;
    //
    //   var byteCharacters = atob(b64Data);
    //   var byteArrays = [];
    //
    //   for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //     var slice = byteCharacters.slice(offset, offset + sliceSize);
    //
    //     var byteNumbers = new Array(slice.length);
    //     for (var i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }
    //
    //     var byteArray = new Uint8Array(byteNumbers);
    //
    //     byteArrays.push(byteArray);
    //   }
    //
    //   var blob = new Blob(byteArrays, {type: contentType});
    //   return blob;
    // }
    //
    // async downloadAllImages () {
    //   const regions = await this.getAvailableRegions()
    //   for (let i = 0; i < regions.length; i++) {
    //     const imagesArray = await this.getRegionsInformation([regions[i]], REGION_INFORMATION_FLAGS.IMAGES)   // REGION_INFORMATION_FLAGS.IMAGES = 64
    //     const images = imagesArray.length > 0 ? imagesArray[0] : null
    //     if (images && images.images) {
    //       for (let j = 0; j < images.images.length; j++) {
    //         const blob = this.b64toBlob(images.images[j], 'image/gif')
    //         await CordovaFileHelper.writeToFile(blob, regions[i] + `-${j + 1}.jpg`, 'images')
    //         await timeout(10)
    //       }
    //     }
    //   }
    // }

  }]);
  return Safeture;
}();
/**
 *
 * @type {Safeture}
 */


var safeture = new Safeture();
var _default = safeture;
exports["default"] = _default;